import { get, handleResponse, postAuth } from "./base.service";
import { CONTROLLER, ACTION } from "../utilities/api.constants";

export const addMember = (name, surName, phone, text, kvkkIzni, kvkkMetni) => {
  var data = { adi: name, soyadi: surName, tel: phone, not: text, kvkkIzni: kvkkIzni, kvkkMetni: kvkkMetni };
  return postAuth(CONTROLLER.LOYALTY + ACTION.ADD_MEMBER, data).then(
    handleResponse
  );
};

export const getReferences = () => {
  return get(CONTROLLER.LOYALTY + ACTION.GET_REFERENCES).then(handleResponse);
};
